<template>
	<PopupRouterViewDetail label="Scheduler Configuration Detail" @copyDataMethod="copyDataAction">
<!-- APP_DETAIL_HEADER -->
		<b-card>
			<b-col cols="12" lg="6">
					<b-form-group id="fieldset-interval-type" label-cols-sm="4" label-cols-lg="3" label="Interval Type" label-for="filter-interval-type">
						{{ model != null ? ( model.intervalType != null ? model.intervalType.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-interval-value" label-cols-sm="4" label-cols-lg="3" label="Interval Value" label-for="filter-interval-value">
						{{ model != null ? model.intervalValue : "" }}
					</b-form-group>
					<b-form-group id="fieldset-interval-value2" label-cols-sm="4" label-cols-lg="3" label="Interval Value 2" label-for="filter-interval-value2">
						{{ model != null ? model.intervalValue2 : "" }}
					</b-form-group>
					<b-form-group id="fieldset-interval-value3" label-cols-sm="4" label-cols-lg="3" label="Interval Value 3" label-for="filter-interval-value3">
						{{ model != null ? model.intervalValue3 : "" }}
					</b-form-group>
					<b-form-group id="fieldset-cron-expression" label-cols-sm="4" label-cols-lg="3" label="Cron Expression" label-for="filter-cron-expression">
						{{ model != null ? model.cronExpression : "" }}
					</b-form-group>
					<b-form-group id="fieldset-job-type" label-cols-sm="4" label-cols-lg="3" label="Job Type" label-for="filter-job-type">
						{{ model != null ? ( model.jobType != null ? model.jobType.jobName : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-recurring-job-id" label-cols-sm="4" label-cols-lg="3" label="Recurring Job Id" label-for="filter-recurring-job-id">
						{{ model != null ? model.recurringJobId : "" }}
					</b-form-group>
			</b-col>
		</b-card>
<!-- END_APP_DETAIL_HEADER -->
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterViewDetail>
</template>
<script>
/*APP_DETAIL_IMPORT*/
import SchedulerConfiguration from '@/models/SchedulerConfiguration/SchedulerConfiguration';
import SchedulerConfigurationList from '@/models/SchedulerConfiguration/SchedulerConfigurationList';
import SchedulerConfigurationFilter from '@/filters/SchedulerConfiguration/SchedulerConfigurationFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
/*END_APP_DETAIL_IMPORT*/
export default {
	components : {
	/*APP_DETAIL_PROP_DEFINITION*/
	PopupRouterViewDetail,AppInputDatetimepicker,AppInputDatetimepickerRange,
	/*APP_DETAIL_COMPONENTS_DEFINITION*/
},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			model: {},
			/*APP_DETAIL_PAGINATION*/
			/*END_APP_DETAIL_PAGINATION*/
			/*APP_DETAIL_FILTER*/
			filterSchedulerConfiguration : null,
			/*END_APP_DETAIL_FILTER*/
			/*APP_DETAIL_PAGING_DEFINITION*/
			currentSchedulerConfigurationPage : 1,
			schedulerConfigurationPageSize: 10,
			/*END_APP_DETAIL_PAGING_DEFINITION*/
			/*APP_DETAIL_SORT_DEFINITION*/
			sortBySchedulerConfiguration: '',
			sortDescSchedulerConfiguration: '',
			/*END_APP_DETAIL_SORT_DEFINITION*/
			/*APP_DETAIL_VARIABLE_DEFINITION*/
			/*END_APP_DETAIL_VARIABLE_DEFINITION*/
			/*APP_DETAIL_OBJ_VARIABLE*/
			/*END_APP_DETAIL_OBJ_VARIABLE*/
		}
	},
	methods : {
		/*APP_DETAIL_GETSchedulerConfiguration*/
		getSchedulerConfiguration : async function(id) {
			this.isBusy = true;
			SchedulerConfiguration.getData(this, id).then(result => { this.model = result; this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		/*END_APP_DETAIL_GETSchedulerConfiguration*/
		/*APP_DETAIL_COPYDATA*/
		copyDataAction(modelEvent) {
			this.$router.push({ name: 'schedulerconfigurationcopydata', params: { id: this.modelId, copydata : 1 } })
		},
		/*END_APP_DETAIL_COPYDATA*/
		/*APP_DETAIL_DISPLAYFILTER*/
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		/*END_APP_DETAIL_DISPLAYFILTER*/
	},
	/*APP_DETAIL_BEFORE_MOUNT*/
	beforeMount() {
		this.filterSchedulerConfiguration = new SchedulerConfigurationFilter();
	},
	/*END_APP_DETAIL_BEFORE_MOUNT*/
	/*APP_DETAIL_MOUNTED*/
	mounted(){
		let id = this.$route.params.id;
		this.modelId = id;
		this.getSchedulerConfiguration(id);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	/*END_APP_DETAIL_MOUNTED*/
	watch : {
	},
	/*APP_DETAIL_COMPUTED*/
	computed: {
	}
	/*END_APP_DETAIL_COMPUTED*/
}
</script>
